import { ArrowUpRight } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 h-12 px-6 text-[13px] font-medium uppercase tracking-[0.14em] border";

export const BuyButton = ({ variant, testId, className = "" }) => {
  if (!variant.whopUrl) {
    return (
      <button
        type="button"
        disabled
        aria-disabled="true"
        data-testid={testId}
        className={`${base} cursor-not-allowed border-black/15 bg-transparent text-black/40 ${className}`}
      >
        Coming Soon
      </button>
    );
  }
  return (
    <a
      href={variant.whopUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} group border-black bg-black text-white transition-colors duration-300 hover:bg-transparent hover:text-black ${className}`}
    >
      Buy Now
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.5} />
    </a>
  );
};
